import React from 'react'

const Banner = (props) => (
    <section id="banner" className="major">
        <div className="inner">
            <header className="major">
                <h1>Horovatin Consulting Ltd.</h1>
            </header>
            <div className="content">
                <p>An Alberta company providing Human Resources services <br />
                and salary surveys to Alberta municipalities.</p>
                <ul className="actions">
                    <li><a href="#one" className="button next scrolly">Learn More</a></li>
                </ul>
            </div>
        </div>
    </section>
)

export default Banner
